import { inject, Injectable } from '@angular/core';
import { MatSnackBar, type MatSnackBarConfig } from '@angular/material/snack-bar';
import type { AlertData } from './alert-data.type';
import { AlertComponent } from './alert.component';

@Injectable({ providedIn: 'root' })
export class AlertService {
  private readonly snackbar = inject(MatSnackBar);

  success(title: string, message?: string, details?: Array<string>): void {
    this.open({ type: 'success', title, message: message, details });
  }

  warning(title: string, message?: string, details?: Array<string>): void {
    this.open({ type: 'warning', title, message: message, details });
  }

  open(data: AlertData, config: Omit<MatSnackBarConfig, 'data'> = {}): void {
    this.snackbar.openFromComponent(AlertComponent, {
      data,
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 5000,
      panelClass: `alert-${data.type}`,
      ...config,
    });
  }
}
